import { render, staticRenderFns } from "./ExportarController.vue?vue&type=template&id=472d0258&"
import script from "./ExportarController.vue?vue&type=script&lang=js&"
export * from "./ExportarController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports